import { fetchUserAttributes } from 'aws-amplify/auth';
import { ConsoleLogger } from 'aws-amplify/utils';

export let USER_NAME: string = ""
export let USER_EMAIL: string = ""

const logger = new ConsoleLogger("LoginUser.tsx")

export function getUsername() {
    fetchUserAttributes()
        .then(attributes => {
            const email = attributes.email as string | undefined;
            if (email) {
                logger.info("USER_NAME = " + email.split("@")[0])
                USER_NAME = email.split("@")[0]
                USER_EMAIL = email
            }
        })
        .catch(err => {
            logger.error(err)
        });
}